export default  function () {
    return [
        {
            registeredName: 'registered name',
            tradingName: 'trading name',
            entityRegistrationNumber: 'entity registration number',
            annualTurnOver:'annual turn over'
        }
    ];
}